import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from './router'
import vuetify from './plugins/vuetify';
import repoIrricrops from '@/models/repoIrricrops'
import slack from '@/plugins/slack'
import userModel from '@/models/userModel'

const url = repoIrricrops.defaults.baseURL; //"https://agroapi.irricrops.com/api";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status          : '',
    token           : localStorage.getItem('token') || '',
    user            : {},
    empresas        : [],
    empresaSelected : null,
    showedSnackBar  : false,
    snackbarText    : "no text",
    baseUrl         : url,
    roles           : [],
    abilities       : []
  },
  getters : {
    isLoggedIn      : state => !!state.token,
    isTest          : state => url == "https://agroapitest.irricrops.com/api/",
    authStatus      : state => state.status,
    userName        : state => state.user !== {} ? state.user.name: "",
    userEmail       : state => state.user !== {} ? state.user.email: "",
    user            : state => state.user,
    roles           : state => state.roles,
    abilities       : state => state.abilities,
    empresas        : state => state.empresas,
    empresaSelected : state => state.empresaSelected,
    baseUrl         : state => state.baseUrl,
    showedSnackBar  : state => state.showedSnackBar,
    snackbarText    : state => state.snackbarText,
    isMobile        : state => vuetify.framework.breakpoint.smAndDown
  },
  mutations: {

    auth_request(state) {
      state.status = 'loading'
    },
    auth_success(state, token) {
      state.status = 'success'
      state.token = token
      axios.defaults.headers.common['Authorization'] = "Bearer "+token;
      repoIrricrops.defaults.headers.common['Authorization'] = "Bearer "+token;
    },
    auth_error(state) {
      state.status = 'error'
    },
    set_user(state, user){
      state.user = user;
    },
    set_temporadas(state, temporadas){
      state.temporadas = temporadas;
    },
    set_empresas(state, empresas){
      state.empresas = empresas;
    },
    set_empresa_selected(state, empresa){
      state.empresaSelected = empresa;
      router.push({ query: { eid: empresa.id }});
    },
    set_rol(state,roles){
      state.roles = roles;
    },
    set_abilities(state,abilities){
      state.abilities = abilities;
    },
    logout(state) {
      state.status = ''
      state.token = ''
    },
    hideSnackBar(state){
      state.showedSnackBar = false;
    },
    showSnackBar(state, text){
      state.showedSnackBar = true;
      state.snackbarText = text;
    }

  },
  actions: {

    login({ commit , dispatch}, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({ url: url+'auth/login', data: user, method: 'POST' })
          .then(resp => {
            const token = resp.data.access_token;
            localStorage.setItem('token', token);
            commit('auth_success', token)
            dispatch('getDataUser').then(() => {
              resolve(resp)
              slack.notify("login "+ user.email);
            });
          })
          .catch(err => {
            commit('auth_error')
            localStorage.removeItem('token')
            reject(err)
          })
      })
    },
    getDataUser({commit, dispatch}){
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({ url: url+'auth/me', method: 'POST' })
          .then(resp => {
            const user         = resp.data;
              commit('set_user'     , user)
              dispatch('getEmpresas').then(() => {
                resolve(resp)
              });
          })
          .catch(err => {
            commit('auth_error')
            localStorage.removeItem('token')
            reject(err)
          })

      })
    },

    getEmpresas({commit, getters}){
      return new Promise((resolve, reject) => {
        var user_id = getters.user.id;
        //axios({ url: url+'user/'+user_id, method: 'GET' })
        userModel.get(user_id)
        .then(resp => {
          commit('set_rol'       , resp.data.data.roles)
          commit('set_abilities' , resp.data.data.habilidades)
          commit('set_empresas'  , resp.data.data.empresas)
          if(resp.data.data.empresas.length > 0){
            var eid = router.app._route.query.eid;
            if(eid){
              var empresa = _.find(resp.data.data.empresas, {id: parseInt(eid)});
              commit('set_empresa_selected', empresa)
            }else{
              commit('set_empresa_selected', _.first(resp.data.data.empresas))
            }
          }
          resolve(resp);
        })
      })
    },

    register({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({ url: url+'signup', data: user, method: 'POST' })
          .then(resp => {
            const token = resp.data.token
            //const user = resp.data.user
            localStorage.setItem('token', token)
            // Add the following line:
            axios.defaults.headers.common['Authorization'] = token
            commit('auth_success', token)
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error', err)
            localStorage.removeItem('token')
            reject(err)
          })
      })
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        commit('logout')
        localStorage.removeItem('token')
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    }
  }
})
